import { getI18n, registerEntityEndpoint, BRANDS, VuetifyValidationRules, SEARCH_DEBOUNCE, formatDateddMMyyyy, formatDate, useNotificationStore, CMSNotification } from "@editor/ui-utils";
import { QTooltip, QSelect, QItemSection, QItemLabel, QItem, QChip } from "quasar";
import { defineComponent, ref, computed, watch, createBlock, openBlock, mergeProps, withCtx, createVNode, createTextVNode, toDisplayString, normalizeProps, onMounted } from "vue";
import { useI18n } from "vue-i18n";
const de = {
  authorsApi: {
    createAlreadyExists: "Autor konnte nicht erstellt werden. Ein Autor mit diesem Namen existiert bereits",
    updateAlreadyExists: "Autor konnte nicht aktualisiert werden. Ein Autor mit diesem Namen existiert bereits",
    created: "Autor erstellt",
    updated: "Autor aktualisiert",
    notFound: "Autor nicht gefunden",
    requiredFields: "Sie können den Autor nicht speichern, da Pflichtangaben fehlen",
    invalidEmail: "Sie können den Autor nicht speichern, da die E-Mail-Adresse ungültig ist"
  },
  authorsList: {
    title: "Autoren",
    newButton: "Neuer Autor",
    name: "Nach Name suchen",
    status: "Status",
    dpAny: "Beliebig",
    statusActive: "Aktiv",
    statusInactive: "Inaktiv",
    loading: "Lade Autoren",
    headerStatus: "Status",
    headerName: "Anzeigename",
    headerCreatedAt: "Erstellt am",
    messageActive: "Autor aktiv",
    messageInactive: "Autor geblockt",
    dpEdit: "Bearbeiten",
    dpActive: "Blockieren",
    dpView: "Anzeigen",
    dpInactive: "Unblockieren",
    noEditTooltip: "Dieser Autor stammt ursprünglich vom {source}-Editor",
    statusBrands: "Marken"
  },
  authorsSelector: {
    changeDateLabel: "Letzte Aktualisierung"
  },
  authors: {
    firstname: "Vorname",
    lastname: "Nachname",
    isEnabled: "Aktiv",
    legacyAuthors: "Legacy-Autor",
    backButton: "Zurück zur Autorenliste",
    displayName: "Anzeigename",
    jobTitle: "Jobtitel",
    biography: "Biografie",
    xing: "Xing-URL",
    linkedin: "LinkedIn-URL",
    twitter: "X-URL (Ex-Twitter)",
    facebook: "Facebook-URL",
    instagram: "Instagram-URL",
    tiktok: "Tiktok-URL",
    email: "E-Mail-Adresse",
    settings: "Einstellungen",
    showArticles: "Artikel anzeigen",
    vgWort: "VG-Wort-Nummer (Karteinummer)",
    profileUrl: "Autorenprofil URL",
    path: "Pfad",
    pathPlaceholder: "Wird automatisch ausgefüllt",
    toAuthorProfile: "Zum Autorenprofil",
    toAuthorPage: "Zum Autor",
    messageMandatoryInfo: "Du kannst den Autor noch nicht speichern, da benötigte Informationen fehlen.",
    messageUpdated: "Autor aktualisiert",
    messageCopy: "Path copied to clipboard",
    messageCreated: "Autor erstellt",
    createdAssigned: "Autor erstellt und mit Nutzer verknüpft",
    selectAuthors: "Autor(en)",
    errorFailedLoadAuthor: "Der Autor konnte nicht geladen werden",
    handledInLegacySystem: "Dieser Autor wird in {source} behandelt, Sie können ihn nicht auf Vibe bearbeiten",
    hasBeenMerged: "Dieser Autor wird nicht mehr verwendet, da er mit {link} zusammengeführt wurde. Bitte bearbeiten Sie die Autorendaten dort.",
    jobTitlePrefix: "Job title prefix",
    router: {
      createAuthor: "Autor erstellen",
      editAuthor: "Autor bearbeiten"
    }
  },
  authorMerge: {
    preMergeBtn: "Vorab-Informationen",
    startMergeBtn: "Autoren-Merge starten",
    startReMergeBtn: "Autoren erneut zusammenführen",
    reMergeTooltip: "Alle Legacy-Autoren der angegebenen Marke, die bereits mit einem Vibe-Autor zusammengeführt wurden, werden erneut mit demselben Vibe-Autor zusammengeführt.",
    allowedMergeToggle: "Zusammengeführte Autoren zulassen",
    allowedMergeTooltip: "Bereits zusammengeführte Legacy-Autoren dürfen erneut zusammengeführt werden, wenn sie in VIBE-Autoren referenziert werden",
    issuesTitle: "Fehlerbericht",
    mergeDialogTitle: "Sind Sie sicher, dass Sie Legacy-Autoren zusammenführen möchten?",
    mergeDialogMessage: "Das Zusammenführen eines Legacy-Autors mit einem Vibe-Autor ist ein irreversibler Vorgang. Der Vibe-Autor bleibt erhalten und wird künftig in Artikeln anstelle des ausgewählten Legacy-Autors referenziert. Möchten Sie fortfahren?",
    singleAuthorMergeLabel: "Autoren merge",
    singleAuthorMergeTooltip: "Führt den Legacy-Autor mit dem aktuellen VIBE-Autor zusammen, übernimmt dabei bestimmte Felder und die Verantwortung für frühere Artikel",
    singleAuthorMergeSuccessMsg: "Autor erfolgreich zusammengeführt: {message}",
    singleAuthorMergeIssueMsg: "Merge Problem aufgetreten:",
    singleAuthorMergeMandatoryInfoMissingMsg: "Pflichtfelder beim Autor fehlen, um die Zusammenführung durchzuführen"
  }
};
const en = {
  authorsApi: {
    createAlreadyExists: "Can't create author because another author with this name already exists",
    updateAlreadyExists: "Can't update author because another author with this name already exists",
    created: "Author created",
    updated: "Author updated",
    notFound: "Author not found",
    requiredFields: "You can't save the author because mandatory information is missing",
    invalidEmail: "You can't save the author because provided email address is invalid"
  },
  authorsList: {
    title: "Authors",
    newButton: "New Author",
    name: "Search by name",
    status: "Status",
    dpAny: "All",
    statusActive: "Active",
    statusInactive: "Inactive",
    loading: "Loading authors",
    headerStatus: "Status",
    headerName: "Display name",
    headerCreatedAt: "Created at",
    messageActive: "Author active",
    messageInactive: "Author blocked",
    dpEdit: "Edit",
    dpView: "View",
    dpActive: "Block",
    dpInactive: "Unblock",
    noEditTooltip: "This author is originally from the {source} editor",
    statusBrands: "Brands"
  },
  authorsSelector: {
    changeDateLabel: "Last update"
  },
  authors: {
    firstname: "First name",
    lastname: "Last name",
    isEnabled: "Active",
    legacyAuthors: "Legacy Author",
    backButton: "Back to authors list",
    displayName: "Display name",
    jobTitle: "Job title",
    biography: "Biography",
    xing: "Xing URL",
    linkedin: "LinkedIn URL",
    twitter: "Twitter URL",
    facebook: "Facebook URL",
    instagram: "Instagram URL",
    tiktok: "Tiktok URL",
    email: "Email",
    settings: "Settings",
    showArticles: "Show articles",
    vgWort: "VG-Wort Author number",
    profileUrl: "Author profile URL",
    path: "Path",
    pathPlaceholder: "Will be automatically filled",
    toAuthorProfile: "To authors profile",
    toAuthorPage: "To Author",
    messageMandatoryInfo: "You can't save the author yet because mandatory information is missing.",
    messageUpdated: "Author updated",
    messageCopy: "Path copied to clipboard",
    messageCreated: "Author created",
    createdAssigned: "Autor created and assigned to user",
    selectAuthors: "Author",
    errorFailedLoadAuthor: "Failed to load author",
    handledInLegacySystem: "This author is being handled in {source}, you can't edit it on Vibe",
    hasBeenMerged: "This author is no longer relevant, author was merged to {link}, please edit author details there",
    jobTitlePrefix: "Job title prefix",
    router: {
      createAuthor: "Create author",
      editAuthor: "Edit author"
    }
  },
  authorMerge: {
    preMergeBtn: "Pre-merge info",
    startMergeBtn: "Start author merge",
    startReMergeBtn: "Re-merge authors",
    reMergeTooltip: "All legacy authors of the given brand, that have been already merged into some Vibe authors. Will be merged again into same Vibe author.",
    allowedMergeToggle: "Allow merged authors",
    allowedMergeTooltip: "Already merged legacy authors will be allowed to be merged again if they are referenced in VIBE authors",
    issuesTitle: "Issue report",
    mergeDialogTitle: "Are you sure you want to merge legacy authors?",
    mergeDialogMessage: "Merging a legacy author into a Vibe author is an irreversible process. The Vibe author will remain, and it will now be referenced in articles instead of the selected legacy author. Do you want to proceed?",
    singleAuthorMergeLabel: "Merge authors",
    singleAuthorMergeTooltip: "Merges legacy author into current VIBE author, inheriting some fields and taking ownership of legacy articles",
    singleAuthorMergeSuccessMsg: "Author merged successfully",
    singleAuthorMergeIssueMsg: "Merge issue encountered: {message}",
    singleAuthorMergeMandatoryInfoMissingMsg: "Mandatory fields are missing on author in order to perform merge"
  }
};
const messages = { en, de };
const routes = [
  {
    path: "/authors",
    children: [
      {
        path: "",
        name: "authors_list",
        component: () => import("./author-list.view-Cn3o7go8.js"),
        meta: { requiredRight: "navigate_list_authors" }
      },
      {
        path: "new",
        name: "author_new",
        component: () => import("./author-edit.view-DXh_Cu8L.js"),
        props: () => ({ title: getI18n().t("authors.router.createAuthor"), backRoute: "/authors" }),
        meta: { requiredRight: ["navigate_author"] }
      },
      {
        path: ":id",
        name: "author_detail",
        component: () => import("./author-edit.view-DXh_Cu8L.js"),
        props: (route) => ({ title: getI18n().t("authors.router.editAuthor"), id: route.params.id, backRoute: "/authors" }),
        meta: { requiredRight: ["navigate_author"] }
      },
      {
        path: "/author-merge",
        name: "author_merge",
        component: () => import("./author-merge.view-BW2SjtAn.js"),
        meta: { requiredRight: "navigate_author_merge" }
      }
    ]
  }
];
const AUTHOR_BRAND_DEFAULT = {
  title: "",
  legacyAuthorUuid: void 0,
  biography: "",
  isEnabled: false,
  type: "BRAND_AUTHOR"
};
const getBrandDefault = (brand) => {
  return { ...AUTHOR_BRAND_DEFAULT, brand };
};
const AuthorModelName = "Authors";
const AuthorService = registerEntityEndpoint(AuthorModelName);
const { getEntity, listEntities, putEntity, postEntity } = AuthorService;
const getAuthors = async (search, params = {}) => {
  return listEntities({ params: { search, ...params } });
};
const getAuthor = async (id) => {
  return getEntity(id);
};
const postAuthor = async (author) => {
  return postEntity(author);
};
const editAuthor = async (author) => {
  const { _id, ...payload } = author;
  return putEntity(_id, payload);
};
const getDefaultStateAuthor = () => ({
  firstname: "",
  lastname: "",
  affiliation: "",
  showArticles: false,
  brandAuthorsRef: BRANDS.map(getBrandDefault),
  socialLinks: {
    twitter: "",
    facebook: "",
    tiktok: "",
    instagram: "",
    xing: "",
    linkedin: "",
    email: ""
  },
  vgWort: "",
  paths: [
    {
      type: "generated",
      path: "",
      createDate: /* @__PURE__ */ new Date()
    }
  ],
  isEnabled: true,
  legacy: {
    source: "vibe",
    isEditableInCTF: true,
    isRenderedByCTF: true,
    hasBeenModifiedInCTF: true
  },
  jobTitlePrefix: "default",
  createDate: /* @__PURE__ */ new Date(),
  changeDate: /* @__PURE__ */ new Date(),
  _id: ""
});
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "author-dropdown-selector",
  props: {
    modelValue: { type: [String, Array], required: false, default: void 0 },
    multiple: { type: Boolean, required: false, default: false },
    disable: { type: Boolean, required: false, default: false },
    required: { type: Boolean, required: false, default: false },
    source: { type: String, required: false, default: void 0 },
    disableMerged: { type: Boolean, required: false, default: void 0 },
    hasExtendedAuthorInfo: { type: Boolean, required: false, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const t = useI18n().t;
    const props = __props;
    const emit = __emit;
    const authorsList = ref([]);
    const authorsOptions = computed(
      () => authorsList.value.map((author) => ({
        label: `${author.firstname} ${author.lastname}`,
        value: author._id,
        legacyId: author.legacy.id,
        lastUpdate: author.changeDate
      }))
    );
    const localModel = computed({
      get: () => props.modelValue,
      set: (items) => {
        if (!items) {
          return emit("update:modelValue");
        }
        emit("update:modelValue", items);
      }
    });
    const rules = computed(() => props.required ? [VuetifyValidationRules.required] : []);
    __expose({ authorsList });
    function filterSearch(search, update) {
      update(async () => {
        const { list } = await getAuthors(search, {
          searchfields: ["firstname", "lastname", "legacy.id"],
          isEnabled: true,
          source: props.source,
          disableMerged: props.disableMerged
        });
        authorsList.value = list;
      });
    }
    const loadSelectedAuthors = async () => {
      if (!props.modelValue)
        return [];
      const selected = Array.isArray(props.modelValue) ? [...props.modelValue] : [props.modelValue];
      const list = new Set(authorsList.value.map((author) => author._id));
      return Promise.all(selected.filter((uuid) => !list.has(uuid)).map(getAuthor));
    };
    watch(
      () => props.modelValue,
      async () => {
        const { list } = await getAuthors(void 0, { source: props.source, disableMerged: props.disableMerged });
        const selected = await loadSelectedAuthors();
        authorsList.value = [...selected, ...list];
      },
      { immediate: true }
    );
    const __returned__ = { t, props, emit, authorsList, authorsOptions, localModel, rules, filterSearch, loadSelectedAuthors, get formatDate() {
      return formatDate;
    }, get formatDateddMMyyyy() {
      return formatDateddMMyyyy;
    }, get SEARCH_DEBOUNCE() {
      return SEARCH_DEBOUNCE;
    }, get QItem() {
      return QItem;
    }, get QItemLabel() {
      return QItemLabel;
    }, get QItemSection() {
      return QItemSection;
    }, get QSelect() {
      return QSelect;
    }, get QTooltip() {
      return QTooltip;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QSelect"], mergeProps({
    modelValue: $setup.localModel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.localModel = $event),
    dense: "",
    outlined: "",
    label: $setup.t("authors.selectAuthors"),
    "use-chips": $props.multiple,
    multiple: $props.multiple,
    "input-debounce": $setup.SEARCH_DEBOUNCE,
    "emit-value": "",
    "map-options": "",
    "use-input": "",
    clearable: !$props.required,
    "clear-icon": $props.required ? void 0 : "x",
    "dropdown-icon": "expand_more",
    disable: $props.disable,
    options: $setup.authorsOptions,
    rules: $setup.rules
  }, _ctx.$attrs, { onFilter: $setup.filterSearch }), {
    option: withCtx((scope) => [
      $props.hasExtendedAuthorInfo ? (openBlock(), createBlock(
        $setup["QItem"],
        mergeProps({ key: 0 }, scope.itemProps, { class: "relative-position" }),
        {
          default: withCtx(() => [
            createVNode(
              $setup["QItemSection"],
              null,
              {
                default: withCtx(() => [
                  createVNode(
                    $setup["QItemLabel"],
                    null,
                    {
                      default: withCtx(() => [
                        createTextVNode(
                          toDisplayString(scope.opt.label),
                          1
                          /* TEXT */
                        )
                      ]),
                      _: 2
                      /* DYNAMIC */
                    },
                    1024
                    /* DYNAMIC_SLOTS */
                  ),
                  createVNode(
                    $setup["QItemLabel"],
                    { caption: "" },
                    {
                      default: withCtx(() => [
                        createTextVNode(
                          toDisplayString(scope.opt.legacyId),
                          1
                          /* TEXT */
                        )
                      ]),
                      _: 2
                      /* DYNAMIC */
                    },
                    1024
                    /* DYNAMIC_SLOTS */
                  )
                ]),
                _: 2
                /* DYNAMIC */
              },
              1024
              /* DYNAMIC_SLOTS */
            ),
            createVNode(
              $setup["QItemSection"],
              {
                side: "",
                top: ""
              },
              {
                default: withCtx(() => [
                  createVNode(
                    $setup["QItemLabel"],
                    { caption: "" },
                    {
                      default: withCtx(() => [
                        createTextVNode(
                          toDisplayString($setup.formatDateddMMyyyy(scope.opt.lastUpdate)) + " ",
                          1
                          /* TEXT */
                        ),
                        createVNode(
                          $setup["QTooltip"],
                          null,
                          {
                            default: withCtx(() => [
                              createTextVNode(
                                toDisplayString(`${$setup.t("authorsSelector.changeDateLabel")}: ${$setup.formatDate(scope.opt.lastUpdate)}`),
                                1
                                /* TEXT */
                              )
                            ]),
                            _: 2
                            /* DYNAMIC */
                          },
                          1024
                          /* DYNAMIC_SLOTS */
                        )
                      ]),
                      _: 2
                      /* DYNAMIC */
                    },
                    1024
                    /* DYNAMIC_SLOTS */
                  )
                ]),
                _: 2
                /* DYNAMIC */
              },
              1024
              /* DYNAMIC_SLOTS */
            )
          ]),
          _: 2
          /* DYNAMIC */
        },
        1040
        /* FULL_PROPS, DYNAMIC_SLOTS */
      )) : (openBlock(), createBlock(
        $setup["QItem"],
        normalizeProps(mergeProps({ key: 1 }, scope.itemProps)),
        {
          default: withCtx(() => [
            createVNode(
              $setup["QItemSection"],
              null,
              {
                default: withCtx(() => [
                  createVNode(
                    $setup["QItemLabel"],
                    null,
                    {
                      default: withCtx(() => [
                        createTextVNode(
                          toDisplayString(scope.opt.label),
                          1
                          /* TEXT */
                        )
                      ]),
                      _: 2
                      /* DYNAMIC */
                    },
                    1024
                    /* DYNAMIC_SLOTS */
                  )
                ]),
                _: 2
                /* DYNAMIC */
              },
              1024
              /* DYNAMIC_SLOTS */
            )
          ]),
          _: 2
          /* DYNAMIC */
        },
        1040
        /* FULL_PROPS, DYNAMIC_SLOTS */
      ))
    ]),
    _: 1
    /* STABLE */
  }, 16, ["modelValue", "label", "use-chips", "multiple", "input-debounce", "clearable", "clear-icon", "disable", "options", "rules"]);
}
const AuthorDropdownSelector = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__file", "/builds/CT/content-technology-framework/modules/author/editor-ui/src/components/author-dropdown-selector.vue"]]);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "author-tag-selector",
  props: {
    modelValue: { type: Array, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const { t } = useI18n();
    const { required } = VuetifyValidationRules;
    const emit = __emit;
    const authorTagSelector2 = ref();
    const props = __props;
    const filteredDisplayedOptions = ref([]);
    const notificationStore = useNotificationStore();
    const previewOptions = computed(() => {
      return filteredDisplayedOptions.value.map(
        (author) => ({
          label: `${author.firstname} ${author.lastname}`,
          value: author._id
        })
      );
    });
    const getEntityLabelById = async (id) => {
      const author = filteredDisplayedOptions.value.find((author2) => author2._id === id);
      if (!author) {
        try {
          const author2 = await getAuthor(id);
          filteredDisplayedOptions.value.push(author2);
        } catch (error) {
          notificationStore.showNotification(new CMSNotification(t("authors.errorFailedLoadAuthor", { id })));
        }
      }
      return author ? `${author == null ? void 0 : author.firstname} ${author == null ? void 0 : author.lastname}` : "";
    };
    const filteredOptions = (search, update) => {
      update(async () => {
        const { list } = await getAuthors(search, { searchfields: ["firstname", "lastname"], isEnabled: true, source: "vibe" });
        filteredDisplayedOptions.value = list;
      });
    };
    const clearSearchText = () => {
      var _a;
      (_a = authorTagSelector2.value) == null ? void 0 : _a.updateInputValue("");
    };
    const inputBasedAdd = (_inputValue, done) => {
      done();
      clearSearchText();
    };
    const model = computed({
      get() {
        return props.modelValue ?? [];
      },
      set(authorUuid = []) {
        const setModel = authorUuid.map((author) => {
          if (typeof author === "object")
            return author.value;
          return author;
        }) ?? [];
        emit("update:modelValue", setModel);
      }
    });
    onMounted(async () => {
      const { list } = await getAuthors();
      filteredDisplayedOptions.value = list;
    });
    const __returned__ = { t, required, emit, authorTagSelector: authorTagSelector2, props, filteredDisplayedOptions, notificationStore, previewOptions, getEntityLabelById, filteredOptions, clearSearchText, inputBasedAdd, model, get SEARCH_DEBOUNCE() {
      return SEARCH_DEBOUNCE;
    }, get QChip() {
      return QChip;
    }, get QSelect() {
      return QSelect;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QSelect"], mergeProps({
    ref: "authorTagSelector",
    modelValue: $setup.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.model = $event),
    outlined: "",
    dense: "",
    label: $setup.t("authors.selectAuthors"),
    options: $setup.previewOptions,
    rules: [$setup.required],
    "new-value-mode": "add-unique",
    "data-qa-author-tags-selector": "",
    "use-input": "",
    "use-chips": ""
  }, _ctx.$attrs, {
    "map-options": "",
    multiple: "",
    "input-debounce": $setup.SEARCH_DEBOUNCE,
    "dropdown-icon": "expand_more",
    onAdd: $setup.clearSearchText,
    onFilter: $setup.filteredOptions,
    onNewValue: $setup.inputBasedAdd
  }), {
    "selected-item": withCtx((scope) => [
      createVNode($setup["QChip"], {
        "data-qa-author-tag": "",
        removable: "",
        dense: "",
        tabindex: scope.tabindex,
        color: "cyan-1",
        "text-color": "dark",
        onRemove: ($event) => scope.removeAtIndex(scope.index)
      }, {
        default: withCtx(() => [
          createTextVNode(
            toDisplayString(scope.opt.label || $setup.getEntityLabelById(scope.opt)),
            1
            /* TEXT */
          )
        ]),
        _: 2
        /* DYNAMIC */
      }, 1032, ["tabindex", "onRemove"])
    ]),
    _: 1
    /* STABLE */
  }, 16, ["modelValue", "label", "options", "rules", "input-debounce"]);
}
const authorTagSelector = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/builds/CT/content-technology-framework/modules/author/editor-ui/src/components/author-tag-selector.vue"]]);
const authorModule = {
  messages,
  routes
};
export {
  AuthorService as A,
  _export_sfc as _,
  AuthorDropdownSelector as a,
  AUTHOR_BRAND_DEFAULT as b,
  getAuthor as c,
  getBrandDefault as d,
  editAuthor as e,
  authorModule as f,
  getDefaultStateAuthor as g,
  authorTagSelector as h,
  postAuthor as p
};
//# sourceMappingURL=index-BG_0ZutI.js.map
